import React, { useState, useEffect } from "react";
import axios from 'axios';
import { RotatingLines } from 'react-loader-spinner';
import { useNavigate, useParams } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import Select from "react-select";
import 'react-toastify/dist/ReactToastify.css';
function AddCustomer() {

    const [loading, setLoading] = useState(true);
    const [duration, setDuration] = useState({});
    const [availStb, setAvailStb] = useState(true);
    const [status, setStatus] = useState("");
    const [inpStb, setInpStb] = useState("");
    const [network, setNetwork] = useState("");
    const [staff, setStaff] = useState("");
    const [group, setGroup] = useState([]);
    const [detail, setDetail] = useState([]);
    const [options, setOptions] = useState([]);
    const [street, setStreet] = useState([]);
    const [stb, setstb] = useState([]);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const [method, setMethod] = useState('');
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);
    const [fileName, setFileName] = useState("");
    const [isUploading, setIsUploading] = useState(false);
const [isSubmitting, setIsSubmitting] = useState(false);

const [showPopup, setShowPopup] = useState(false);
const [finalData, setFinalData] = useState({});;


    const user = getCookie('user');
    function getCookie(name) {
        const cookies = document.cookie.split('; ');
        for (const cookie of cookies) {
            const [key, value] = cookie.split('=');
            if (key === name) { return value; }
        } return null;
    }
    function details(event) {
        setDetail((event.target.value).split("|"))

    }
    function stbVerify(e) {
        if (inpStb.includes(" ")) {
            toast.warning("do not contain space")
            return
        }
        const selectedStreet = stb.find(t => t.serial_num === inpStb);
        if (selectedStreet) {
            setAvailStb(true);
            toast.warning("STB num not available !")
            setInpStb("");

        } else {
            setAvailStb(false);
            toast.success("STb available")


        }
    }
    function durationChange(e) {
        if (e.name && e.value) {
            setDuration((prev) => ({
                ...prev,
                [e.name]: e.value,
            }));
        } else if (e.target) {
            const { name, value } = e.target;
            setDuration((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    }
    useEffect(() => { if (!user) { navigate('/login') } }, [user, navigate]);
    useEffect(() => {
        setDuration((prev) => ({
            ...prev,
            connectionStatus: "Active", // or your desired default
        }));
    }, []);
useEffect(() => {
  if (method === "new_connection" || method === "shift_connection") {
    setDuration(prev => ({
      ...prev,
      monthPaid: prev.monthPaid || 1
    }));
  }
}, [method]);

    async function fetchData() {
        try {
            const response = await axios.post('https://node.cabletvpay.in/addCustomerNeeds', { user });
            if (response.status === 200) {
                console.log(response.data);
                setGroup(response.data.group);
                setstb(response.data.stb);
                setStreet(response.data.street);
                setOptions((response.data.staff).map((item) => ({
                    value: item.area_code,
                    label: item.name,
                })));
                setStaff(response.data.staff);
            }
        } catch (error) {
            setError(error.response?.data?.message || "Error fetching data");
            console.log(error);
        } finally {
            setLoading(false);
        }

    }
    useEffect(() => {
        let statusValue = "";
        if (method === "free") {
            statusValue = "free";
        } else if (method === "re_connection") {
            statusValue = "unpaid";
        } else if (method === "new_connection" || method === "shift_connection") {
            statusValue = "paid";
        }

        setStatus(statusValue);
        setDuration((prev) => ({
            ...prev,
            Status: statusValue, 
        }));
    }, [method]);


function handleSubmit(e) {
    e.preventDefault();
  
    if (inpStb.trim() === "" || inpStb.includes(" ")) {
        toast.warning("only valid STB numbers accepted");
        return;
    }

    const data = {
        user,
        method,
        inpStb,
        ...duration
    };

    const computedAmounts = calculateFinalData(duration);

    setFinalData(computedAmounts);

    setShowPopup(true);
}
function calculateFinalData(detail) {
    const toNum = (v) => Number(v) || 0;

    const boxAmount = toNum(detail.boxAmount);
    const installationAmount = toNum(detail.installationAmount);
    const Incentive = toNum(detail.Incentive);
    const packageAmount = toNum(detail.packageAmount);
    const pendingAmount = toNum(detail.pendingAmount);
    const discountAmount = toNum(detail.discountAmount);
    const monthPaid = toNum(detail.monthPaid);

    const packageTotal = packageAmount * monthPaid;

    const total =
        boxAmount +
        installationAmount +
        Incentive +
        packageTotal +   
        pendingAmount -
        discountAmount;

    return {
        boxAmount,
        installationAmount,
        Incentive,
        packageAmount,
        monthPaid,
        packageTotal,   
        pendingAmount,
        discountAmount,
        total
    };
}


async function confirmSubmit(e) {
  e.preventDefault();

  if (isSubmitting) return; // 🛑 block multiple clicks
  setIsSubmitting(true);

  try {
    const response = await axios.post(
      'https://node.cabletvpay.in/submitAddCustomer',
      { user, method, detail, duration, inpStb }
    );

    if (response.status === 200) {
      toast.success("Customer Added successfully!");

      // ⏳ 1 second delay then redirect
      setTimeout(() => {
        navigate("/allCustomer/all", {
          state: { customerId: response.data.customer_id }
        });
      }, 1000);
    }

  } catch (err) {
    toast.error(err.response?.data?.message || "error adding customer");
    setIsSubmitting(false); // re-enable if failed
  }
}


    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        if (file && file.name.endsWith(".csv")) {
            setSelectedFile(file);
            setFileName(file.name);
        } else {
            alert("Please upload a valid .csv file.");
        }
    };
    const handleUpload = async () => {
    if (!selectedFile) {
        alert("Please choose a file before uploading.");
        return;
    }

    const formData = new FormData();
    formData.append("csvFile", selectedFile);
    formData.append("user", user);

    try {
        setIsUploading(true);
        const res = await axios.post("https://node.cabletvpay.in/excelUpload", formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
  toast.success("Customer Details Added successfully.");
       
        setSelectedFile(null);
        setFileName("");
    } catch (error) {
        console.error("Upload error:", error.response?.data || error.message);
        alert(error.response?.data?.message || "Upload failed ❌");
    } finally {
        setIsUploading(false);
    }
};

    useEffect(() => {
        fetchData()
    }, [user])


    if (loading) {
        return (<div className="content-wrapper"><div className="d-flex justify-content-center align-items-center" style={{ height: "80vh" }}>  <RotatingLines visible={true} height="80" width="80" strokeColor="#007bff" strokeWidth="2" animationDuration="3" />  </div>  </div>);
    }

    if (error) {
        return (<div className="content-wrapper"><div className="d-flex justify-content-center align-items-center" style={{ height: "73vh" }}>  <img src="../asset/img/errorPage.jpg" alt="Error" style={{ height: "20rem" }} />  </div>  </div>);
    }
    return (
        <div className="content-wrapper">
            <div className="container-fluid">
                <div className="content-header pt-1 ">
                    <div className="mt-3 border-bottom">
                        <div className="fs-4 valuesDec h5">ADD CUSTOMER</div>
                        <ToastContainer theme='dark' />
                    </div>
                    <div className="mx-1 p-1 border-0 mt-3" >
                      <form onSubmit={handleSubmit}>
                            <div className="row  my-0" >
                                <div className={`col-lg-4 col-md-6 col-12 ${method ? "" : "d-none"}`}>
                                    <div className="d-flex justify-content-around">
                                        <div className="input-group">
                                            <label htmlFor="stbNumber" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>STB number : <span className={availStb ? 'text-danger' : 'text-success'}>{availStb === true ? "Not Available" : availStb === false ? "STB available" : ""}</span> </label>
                                            <div className="input-group elevation-3 rounded">
                                                <input type="text" name="stbNumber" id="stbNumber" className="form-control bg-gradient-light text-navy border-dark border-width-2 input-group" placeholder="enter new STB" aria-describedby="basic-addon2" value={inpStb} onChange={(e) => { setInpStb(e.target.value) }} />
                                                <div className="input-group-append">
                                                    <button type="button" className="btn bg-navy btn-group" name="verify" id="verify" onClick={stbVerify} >Verify</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className={`col-lg-4 col-md-6 col-12 ${method ? "" : "d-none"}`}>
                                    <div className="form-group">
                                        <label htmlFor="customerName" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>customer name :</label>
                                        <input type="text" name="customerName" id="customerName" className="form-control text-navy border-dark elevation-3" disabled={availStb} style={{ background: `${availStb ? 'rgb(222, 224, 227)' : 'white'}` }} onChange={durationChange} placeholder="enter name here" required/>
                                    </div>
                                </div>
                                <div className={`col-lg-4 col-md-6 col-12 ${method ? "" : "d-none"}`}>
                                    <div className="form-group">
                                        <label htmlFor="boxType" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>box model/type :</label>
                                        <input type="text" name="boxType" id="boxType" className="form-control text-navy border-dark elevation-3" onChange={durationChange} disabled={availStb} style={{ background: `${availStb ? 'rgb(222, 224, 227)' : 'white'}` }} placeholder="enter box type" required/>
                                    </div>
                                </div>
                                <div className={`col-lg-4 col-md-6 col-12 ${method ? "" : "d-none"}`}>
                                    <div className="form-group">
                                        <label htmlFor="accountNumber" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>account number :</label>
                                        <input type="text" name="accountNumber" id="accountNumber" className="form-control text-navy border-dark elevation-3" disabled={availStb} style={{ background: `${availStb ? 'rgb(222, 224, 227)' : 'white'}` }} onChange={durationChange} placeholder="enter account number" />
                                    </div>
                                </div>
                                <div className={`col-lg-4 col-md-6 col-12 ${method ? "" : "d-none"}`}>
                                    <div className="form-group">
                                        <label htmlFor="customerGroup" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>customer Group :</label>
                                        <select className="form-control text-navy border-dark elevation-3" onChange={durationChange} disabled={availStb} style={{ background: `${availStb ? 'rgb(222, 224, 227)' : 'white'}` }} id="customerGroup" name="customerGroup">
                                            <option value="">none</option>
                                            {group.length > 0 ? (
                                                group.map((row, index) => (
                                                    <option key={index} value={row.group_name}>{row.group_name}</option>
                                                ))
                                            ) : (<option value="">group unavailable</option>)}
                                        </select>
                                    </div>
                                </div>
                                <div className={`col-lg-4 col-md-6 col-12 ${method ? "" : "d-none"}`}>
                                    <div className="form-group">
                                        <label htmlFor="boxAmount" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>box amount :</label>
                                        <input type="text" name="boxAmount" id="boxAmount" className="form-control text-navy border-dark elevation-3" onChange={durationChange} disabled={availStb} style={{ background: `${availStb ? 'rgb(222, 224, 227)' : 'white'}` }} placeholder="enter box  amount" required/>
                                    </div>
                                </div>
                                <div className={`col-lg-4 col-md-6 col-12 ${method ? "" : "d-none"}`}>
                                    <div className="form-group">
                                        <label htmlFor="street" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>Street :</label>
                                        <select className="form-control text-navy border-dark elevation-3" disabled={availStb} style={{ background: `${availStb ? 'rgb(222, 224, 227)' : 'white'}` }} id="street" name="street" onChange={details}>
                                            <option value="none">none</option>
                                            {
                                                street.length > 0 ? (
                                                    street.map((row, index) => (
                                                        <option key={index} value={`${row.street_name}|${row.network_name}|${row.executive_name}|${row.area_code}`}>{row.street_name}</option>
                                                    ))
                                                ) : (<option value="none">none</option>)
                                            }
                                        </select>
                                    </div>
                                </div>
                                <div className={`col-lg-4 col-md-6 col-12 ${method ? "" : "d-none"}`}>
                                    <div className="form-group">
                                        <label htmlFor="flatName" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>Flat name :</label>
                                        <input type="text" name="flatName" id="flatName" className="form-control text-navy border-dark elevation-3" onChange={durationChange} disabled={availStb} style={{ background: `${availStb ? 'rgb(222, 224, 227)' : 'white'}` }} placeholder="enter flat name" />
                                    </div>
                                </div>
                                <div className={`col-lg-4 col-md-6 col-12 ${method ? "" : "d-none"}`}>
                                    <div className="form-group">
                                        <label htmlFor="installationAmount" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>installation amount :</label>
                                        <input type="text" name="installationAmount" id="installationAmount" className="form-control text-navy border-dark elevation-3" disabled={availStb} style={{ background: `${availStb ? 'rgb(222, 224, 227)' : 'white'}` }} placeholder="enter installation amount" onChange={durationChange} required/>
                                    </div>
                                </div>
                                <div className={`col-lg-4 col-md-6 col-12 ${method ? "" : "d-none"}`}>
                                    <div className="form-group">
                                        <label htmlFor="networkName" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>network name :</label>
                                        <select className="form-control text-navy border-dark elevation-3" disabled={availStb} style={{ background: `${availStb ? 'rgb(222, 224, 227)' : 'white'}` }} id="networkName" name="networkName" onChange={durationChange} >
                                            <option value={detail[1]}>{detail[1]}</option>
                                        </select>
                                    </div>
                                </div>
                                <div className={`col-lg-4 col-md-6 col-12 ${method ? "" : "d-none"}`}>
                                    <div className="form-group">
                                        <label htmlFor="mobileNumber" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>mobile number :</label>
                                        <input type="text" name="mobileNumber" id="mobileNumber" className="form-control text-navy border-dark elevation-3" disabled={availStb} style={{ background: `${availStb ? 'rgb(222, 224, 227)' : 'white'}` }} placeholder="enter phone number" onChange={durationChange} required/>
                                    </div>
                                </div>
                                <div className={`col-lg-4 col-md-6 col-12 ${method ? "" : "d-none"}`}>
                                    <div className="form-group">
                                        <label htmlFor="Incentive" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>Incentive Amount :</label>
                                        <input type="text" name="Incentive" id="Incentive" className="form-control text-navy border-dark elevation-3" disabled={availStb} style={{ background: `${availStb ? 'rgb(222, 224, 227)' : 'white'}` }} placeholder="enter phone number" onChange={durationChange} required/>
                                    </div>
                                </div>
                                <div className={`col-lg-4 col-md-6 col-12 ${method ? "" : "d-none"}`}>
                                    <div className="form-group">
                                        <label htmlFor="doorNo" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>door number :</label>
                                        <input type="text" name="doorNo" id="doorNo" className="form-control text-navy border-dark elevation-3" disabled={availStb} style={{ background: `${availStb ? 'rgb(222, 224, 227)' : 'white'}` }} placeholder="enter door number" onChange={durationChange} />
                                    </div>
                                </div>
                                <div className={`col-lg-4 col-md-6 col-12 ${method ? "" : "d-none"}`}>
                                    <div className="form-group">
                                        <label htmlFor="alternateMobileNumber" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>alternate mobile number :</label>
                                        <input type="text" name="alternateMobileNumber" id="alternateMobileNumber" className="form-control text-navy border-dark elevation-3" disabled={availStb} style={{ background: `${availStb ? 'rgb(222, 224, 227)' : 'white'}` }} placeholder="enter alternate mobile number" onChange={durationChange} />
                                    </div>
                                </div>
                                <div className={`col-lg-4 col-md-6 col-12 ${method ? "" : "d-none"}`}>
                                    <div className="form-group">
                                        <label htmlFor="packageAmount" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>package amount <span className="text-success">(default)</span> :</label>
                                        <input type="text" name="packageAmount" id="packageAmount" className="form-control text-navy border-dark elevation-3" disabled={availStb} style={{ background: `${availStb ? 'rgb(222, 224, 227)' : 'white'}` }} placeholder="enter package amount" onChange={durationChange} required/>
                                    </div>
                                </div>
                                <div className={`col-lg-4 col-md-6 col-12 ${method ? "" : "d-none"}`}>
                                    <div className="form-group">
                                        <label htmlFor="status" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>status :</label>
                                        <input
                                            type="text"
                                            name="Status"
                                            id="Status"
                                            className="form-control text-navy border-dark elevation-3"
                                            disabled
                                            value={duration.Status || ""}
                                            style={{ background: availStb ? 'rgb(222, 224, 227)' : 'white' }}
                                            readOnly
                                        />

                                    </div>
                                </div>
                                <div className={`col-lg-4 col-md-6 col-12 ${method ? "" : "d-none"}`}>
                                    <div className="form-group">
                                        <label htmlFor="package" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>package :</label>
                                        <input type="text" name="package" id="package" className="form-control text-navy border-dark elevation-3" disabled={availStb} style={{ background: `${availStb ? 'rgb(222, 224, 227)' : 'white'}` }} placeholder="enter package" onChange={durationChange} required/>
                                    </div>
                                </div>
                                <div className={`col-lg-4 col-md-6 col-12 ${method ? "" : "d-none"}`}>
                                    <div className="form-group">
                                        <label htmlFor="discountAmount" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>discount amount :</label>
                                        <input type="text" name="discountAmount" id="discountAmount" className="form-control text-navy border-dark elevation-3" disabled={availStb} style={{ background: `${availStb ? 'rgb(222, 224, 227)' : 'white'}` }} placeholder="enter discount amount" onChange={durationChange}  />
                                    </div>
                                </div>
                                <div className={`col-lg-4 col-md-6 col-12 ${method ? "" : "d-none"}`}>
                                    <div className="form-group">
                                        <label htmlFor="connectionStatus" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>connection status :</label>
                                        <select
                                            className="form-control text-navy border-dark elevation-3"
                                            id="connectionStatus"
                                            name="connectionStatus"
                                            value={duration.connectionStatus || "Active"}
                                            onChange={durationChange}
                                            disabled={availStb}
                                            style={{ background: availStb ? 'rgb(222, 224, 227)' : 'white' }}
                                        >
                                            <option value="Active">Active</option>
                                            <option value="Deactive">Deactive</option>
                                        </select>

                                    </div>
                                </div>
                                <div className={`col-lg-4 col-md-6 col-12 ${method ? "" : "d-none"}`}>
                                    <div className="form-group">
                                        <label htmlFor="staffCode" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>staff code :</label>
                                        <select className="form-control text-navy border-dark elevation-3" disabled={availStb} style={{ background: `${availStb ? 'rgb(222, 224, 227)' : 'white'}` }} id="staffCode" name="staffCode" required>
                                            {
                                                detail[2] ? (
                                                    <option value={`${detail[2]}|${detail[3]}`}>{`${detail[2]} |(${detail[3]})`}</option>
                                                ) : (
                                                    <option value="">none</option>
                                                )
                                            }
                                        </select>
                                    </div>
                                </div>
                                {/* <div className={`col-lg-4 col-md-6 col-12 ${method ? "" : "d-none"}`}>
                                    <div className="form-group">
                                        <label htmlFor="CmonthBalance" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>current month balance amount :</label>
                                        <input type="text" name="CmonthBalance" id="CmonthBalance" className="form-control text-navy border-dark elevation-3" disabled={availStb} style={{ background: `${availStb ? 'rgb(222, 224, 227)' : 'white'}` }} placeholder="enter current month balance amount" onChange={durationChange} required/>
                                    </div>
                                </div> */}
                                <div className={`col-lg-4 col-md-6 col-12 ${method ? "" : "d-none"}`}>
                                    <div className="form-group">
                                        <label htmlFor="installedBy" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>Installed By :</label>
                                        <Select
                                            options={options}
                                            isMulti
                                            value={selectedOptions}
                                            onChange={(selected) => {
                                                setSelectedOptions(selected);
                                                durationChange({ name: "selectedOptions", value: selected }); // Pass as an object to match other inputs
                                            }}
                                            placeholder="Select an Option"
                                            className="text-navy border-dark elevation-3"
                                            classNamePrefix="select"
                                            isDisabled={availStb}
                                            styles={{
                                                control: (baseStyles) => ({
                                                    ...baseStyles,
                                                    backgroundColor: availStb ? "rgb(222, 224, 227)" : "white",
                                                }),
                                            }}
                                        />                                    </div>
                                </div>
                               <div
  className={`col-lg-4 col-md-6 col-12 ${
    method === "re" || method === "free" || method === "" ? "d-none" : ""
  }`}
>
  <div className="form-group">
    <label
      htmlFor="monthPaid"
      className="text-center valuesDec text-navy"
      style={{ height: "2.4rem" }}
    >
      No of Month Paid{" "}
      <span className="text-orange">( Choose Advance Amount )</span> :
    </label>

    <select
      name="monthPaid"
      id="monthPaid"
      className="form-control text-navy border-dark elevation-3"
      value={duration.monthPaid ?? 1}
      onChange={durationChange}
      disabled={availStb}
      style={{ background: availStb ? "rgb(222, 224, 227)" : "white" }}
      required
    >
      <option value={1}>1 Month</option>
      <option value={2}>2 Months</option>
      <option value={3}>3 Months</option>
        <option value={4}>4 Months</option>
          <option value={5}>5 Months</option>
            <option value={6}>6 Months</option>
              <option value={7}>7 Months</option>
                <option value={8}>8 Months</option>
                  <option value={9}>9 Months</option>
                    <option value={10}>10 Months</option>
                      <option value={11}>11 Months</option>
                        <option value={12}>12 Months</option>
    </select>
  </div>
</div>

                                <div className={`col-lg-4 col-md-6 col-12 ${method ? "" : "d-none"}`}>
                                    <div className="form-group">
                                        <label htmlFor="amountCollectedBy" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>Amount Collected By :</label>
                                        <select
                                            className="form-control text-navy border-dark elevation-3"
                                            disabled={availStb}
                                            style={{ background: availStb ? 'rgb(222, 224, 227)' : 'white' }}
                                            id="amountCollectedBy"
                                            name="amountCollectedBy"
                                            value={duration.amountCollectedBy || ""}  // ✅ make it controlled
                                            onChange={durationChange} required
                                        >
                                            <option value="">none</option>
                                            {staff.length > 0 ? (
                                                staff.map((row, i) => (
                                                    <option key={i} value={`${row.name}`}>
                                                        {`${row.name} - (${row.area_code})`}
                                                    </option>
                                                ))
                                            ) : (
                                                <option value="">No options available</option>
                                            )}
                                        </select>
                                    </div>
                                </div>
                                <div className={`col-lg-4 col-md-6 col-12 ${method ? "" : "d-none"}`}>
                                    <div className="form-group">
                                        <label htmlFor="amountCollectedBy" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>Previous Month Pending Amount :</label>
                                        <input type="text" name="pendingAmount" id="pendingAmount" className="form-control text-navy border-dark elevation-3" disabled={availStb} style={{ background: `${availStb ? 'rgb(222, 224, 227)' : 'white'}` }} placeholder="enter Previous Month Pending Amount" onChange={durationChange} />
                                    </div>
                                </div>
                            </div>
                            <div className={`col-12 ${method ? "" : "d-none"}`}>
                                <div className="text-center mt-4">
                                   <input
    type="submit"
    value="Submit"
    className="btn btn-success p-2 text-bold elevation-2"
   
    disabled={availStb}
/>
                                </div>
                            </div>
                        </form>
                        
{showPopup && (
    <div className="modal fade show d-block" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">

                <div className="modal-header bg-primary text-white">
                    <h5 className="modal-title">Confirm Details</h5>
                    <button type="button" className="btn-close btn-close-white" onClick={() => setShowPopup(false)}></button>
                </div>

                <div className="modal-body">
                   <p>Box Amount : {finalData.boxAmount}</p>
                <p>Installation : {finalData.installationAmount}</p>
                <p>Incentive : {finalData.Incentive}</p>
                <p>Package Amount : {finalData.packageAmount}</p>
                 <p>PaidMonth : {finalData.monthPaid}</p>
                <p>Pending Amount : {finalData.pendingAmount}</p>
                <p>Discount Amount : {finalData.discountAmount}</p>
                <br />
               <p><b>Total Amount : {finalData.total}</b></p>

                    {/* Add all fields */}
                </div>

                <div className="modal-footer">
                    <button className="btn btn-secondary" onClick={() => setShowPopup(false)}>Cancel</button>
                   <button
  className="btn btn-success"
  onClick={confirmSubmit}
  disabled={isSubmitting}
>
  {isSubmitting ? "Submitting..." : "Confirm & Submit"}
</button>

                </div>

            </div>
        </div>
    </div>
)}

                    </div>
                    <div className="form-group mt-3">
                        <label htmlFor="area_code" className="text-center valuesDec text-navy">Connection Type :</label>
                        <select className="form-control bg-gradient-navy text-white border-0 elevation-3 w-25" id="area_code" name="area_code" onChange={(e) => { setMethod(e.target.value) }}>
                            <option value="">select a category</option>
                            <option value="new_connection">New Connection</option>
                            <option value="re_connection">Re Connection</option>
                            <option value="shift_connection">Shift Connection</option>
                            <option value="free">Free Connection</option>
                        </select>
                    </div>
                    <div className="container my-5">
                        <div className="card shadow-lg rounded-4 p-4 bg-light-subtle border-0">
                            <div className="text-center mb-4">
                                <h2 className="fw-bold" style={{ color: "#001f3f" }}>📤 CSV File Upload</h2>
                                <p className="text-secondary">Upload your file in <strong>.csv</strong> format only</p>
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Select CSV File</label>
                                <input
                                    type="file"
                                    accept=".csv"
                                    className="form-control"
                                    onChange={handleFileUpload}
                                />
                                {fileName && <p className="text-success mt-2">Selected: {fileName}</p>}
                            </div>

                            <div className="d-grid">
                                <button
                                    className="btn btn-primary"
                                    onClick={handleUpload}
                                    disabled={isUploading}
                                >
                                    {isUploading ? "Uploading..." : "Upload CSV"}
                                </button>
                            </div>

                            <div className="d-grid mt-4">
                                <a
                                    href="/upload_formate.csv"
                                    download
                                    className="btn btn-success btn-lg fw-semibold"
                                >
                                    📥 Download Sample Format
                                </a>
                            </div>
                        </div>
                    </div>

                </div>
            </div >
        </div >
    );
}
export default AddCustomer;

